import React from "react";
import i18n from "../../../i18n/i18n";
import "./modifyUser.scss";
import UserForm from "../userForm/userForm";
import {RouteComponentProps, withRouter} from "react-router";
import {Api} from "../../../helpers/api";
import {AdministrationService} from "../../services/administrationService";
import {UserInManagementModel} from "../../models/user";
import Loader from "../../../common/components/shared/loader/loader";
import {HttpError} from "../../../common/components/shared/httpError/httpError";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../common/models/httpError";
import {RouteParamsModel} from "../../../common/models/routeParams";

interface ModifyUserState {
    userData?: UserInManagementModel | null;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

class ModifyUser extends React.Component <RouteComponentProps, ModifyUserState> {
    constructor(props: any) {
        super(props);

        this.state = {
            userData: null,
            response: undefined
        };
    }

    async componentDidMount() {
        const params = this.props.match.params as RouteParamsModel;
        const response = await AdministrationService.getUser(params.id);

        this.setState({
            userData: response?.data || null,
            response
        });
    }

    render() {
        return (
            <div className="modify-user">
                <div className="content">
                    <div className="header" data-testid="modify-user-header">
                        {i18n.t("administration.modifyUser.header")}
                        {this.renderContent()}
                    </div>
                </div>
            </div>
        );
    }

    private renderContent() {
        if (!Api.isSuccess(this.state.response)) {
            return <HttpError
                response={this.state.response}
                cause={i18n.t("administration.modifyUser.errors.itemRetrievalErrorSuffix")}
            />;
        } else if (this.state.userData) {
            return <UserForm isUpdate={true} userData={this.state.userData}/>;
        } else {
            return (
                <Loader/>
            );
        }
    }
}

export default withRouter(ModifyUser);
